export default __webpack_public_path__ + "static/media/memoji-4.cf66802f.png";